import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)
const originalPush=VueRouter.prototype.push
VueRouter.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}
const routes = [
  {
    path: '/',
    name: 'Index',
    hidden:false,
    meta:{
      title:'首页'
    },
    component: ()=>import("@/views/index")
  },

  {
    path: '/aboutus',
    name: 'Aboutus',
    hidden:false,
    meta:{
      title:'关于我们'
    },
    component: ()=>import("@/views/aboutus/aboutus.vue")
  },
  {
    path: '/product',
    name: 'Product',
    hidden:false,
    meta:{
      title:'产品页'
    },
    component: ()=>import("@/views/products/product.vue")
  },
  {
    path: '/resolveMethods',
    name: 'resolveMethods',
    hidden:false,
    meta:{
      title:"解决方案"
    },
    component: ()=>import("@/views/resolveMethods/index.vue")
  },
  {
    path: '/afterSales',
    name: 'afterSales',
    hidden:false,
    meta:{
      title:'售后服务'
    },
    component: ()=>import("@/views/afterSales/afterSales.vue")
  },
  {
    path: '/contactus',
    name: 'contactus',
    hidden:false,
    meta:{
      title:'联系我们'
    },
    component: ()=>import("@/views/contactus/contactus.vue")
  },

  {
    path: '/RDpage',
    name: 'RDpage',
    hidden:true,
    meta:{
      title:"研发背景"
    },
    component: ()=>import("@/views/RDbackgroundpage/RDpage.vue")
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    hidden:true,
    meta:{
      title:"新闻详情"
    },
    component: ()=>import("@/views/newsDetails/newsDetails.vue")
  },
  {
    path: '/textDetails/:id',
    name: 'textDetails',
    hidden:true,
    meta:{
      title:"文章详情"
    },
    component: ()=>import("@/views/newsDetails/textDetails.vue")
  },

  {
    path: '/successSimple',
    name: 'successSimple',
    hidden:true,
    meta:{
      title:"成功案例"
    },
    component: ()=>import("@/views/successSimple/successSimple.vue")
  },
  {
    path: '/recruit',
    name: 'recruit',
    hidden:true,
    meta:{
      title:"人才招聘"
    },
    component: ()=>import("@/views/recruit/recruit.vue")
  },
  {
    path: '/jobDetails/:item',
    name: 'jobDetails',
    hidden:true,
    meta:{
      title:"人才招聘"
    },
    component: ()=>import("@/views/recruit/jobDetails.vue")
  },

]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to,from,next)=>{
  window.scrollTo(0,0)
})
export default router
